import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex position-absolute w-100 h-100 align-items-center justify-content-center start-0 top-0",
  style: {"background-color":"rgba(255, 255, 255, 0.5)"}
}
const _hoisted_2 = { class: "d-block text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 h3 text-uppercase fw-bold" }, "Vehículos asociados")
], -1)
const _hoisted_5 = { class: "row my-5" }
const _hoisted_6 = { class: "col-12 my-3" }
const _hoisted_7 = {
  key: 0,
  class: "h3 py-4"
}
const _hoisted_8 = { class: "col-lg-3" }
const _hoisted_9 = { class: "col-lg-5 py-3 py-lg-0" }
const _hoisted_10 = { class: "fw-bold h3 text-uppercase" }
const _hoisted_11 = { class: "h6 fw-light" }
const _hoisted_12 = { class: "col-lg my-3 my-lg-0" }
const _hoisted_13 = {
  key: 0,
  class: "h3"
}
const _hoisted_14 = { class: "col-1" }
const _hoisted_15 = {
  key: 0,
  height: "45",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  style: {"fill":"green"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", { d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  height: "45",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  style: {"fill":"red"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", { d: "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 2,
  height: "45",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  style: {"fill":"gray"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", { d: "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM96 75l0-11 192 0 0 11c0 19-5.6 37.4-16 53L112 128c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9L112 384z" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "col-12 my-3" }
const _hoisted_26 = {
  key: 0,
  class: "col-md-7"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-danger fw-bold" }, " Atención: Verifique que el documento sea el correcto, NO podrá modificarlo posteriormente y será utlizado en cualquier gestion dentro del sitio web ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 my-5" }, null, -1)
const _hoisted_29 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_30 = ["disabled"]

import { userService } from '@/services/user.service'
import { onMounted, reactive, ref } from 'vue'
import VipUser from './form/VipUser.vue'
import FormDni from './form/FormDni.vue'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'
import { Form, useForm } from 'vee-validate'
import useLoading from '@/composables/useLoading'
import BaseImg from './rebranding/BaseImg.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormVehiculosAsociados',
  setup(__props) {

const { loading, setSearch } = useLoading(false)

const { state, commit } = useStore<VuexStore>(key)

const { handleSubmit } = useForm()

const vehiculos = ref<
  {
    id: number
    vin: string
    clasico: boolean
    validado: number
    modelo: string
  }[]
>([])

const asociarAccion = ref(false)
const form = reactive({
  documento: state.authUser?.documento ?? '',
  documentacion: {
    vin: '',
    imagenDni: '',
    imagenLicence: '',
    imagenFirma: '',
    isClient: null
  }
})
onMounted(async () => {
  const data = await userService.vehiculosAsociados()
  vehiculos.value = data
})

const agregarVehiculoSubmit = handleSubmit(async () => {
  try {
    setSearch(true, 'Agregando Vehiculo')
    const agregado = await userService.agregarVehiculo({
      ...form.documentacion,
      documento: form.documento
    })
    if (agregado && state.authUser) {
      commit('SET_DOCUMENTO', form.documento)
      if (form.documentacion.isClient) {
        commit('SET_FIDELIZAR')
      }
    }
    return
  } finally {
    const data = await userService.vehiculosAsociados()
    vehiculos.value = data
    asociarAccion.value = false
    setSearch(false, '')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(loading).status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("h6", null, _toDisplayString(_unref(loading).text), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (!asociarAccion.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, [
              (!vehiculos.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Todavia no hay vehículos asociados "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vehiculos.value, (vehiculo) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: vehiculo.id,
                  class: "row my-3 align-items-center"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(BaseImg, {
                      alt: vehiculo.modelo
                    }, null, 8, ["alt"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(vehiculo.modelo), 1),
                    _createElementVNode("div", _hoisted_11, "vin: " + _toDisplayString(vehiculo.vin), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (vehiculo.clasico)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Modelo clasico "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (vehiculo.validado === 1)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17))
                      : _createCommentVNode("", true),
                    (vehiculo.validado === 0)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_20))
                      : _createCommentVNode("", true),
                    (vehiculo.validado === -1)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_21, _hoisted_23))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_24, [
              (!asociarAccion.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary px-4 py-2",
                    type: "submit",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (asociarAccion.value = true))
                  }, " Asociar nuevo vehiculo "))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : (_openBlock(), _createBlock(_unref(Form), {
            key: 1,
            onSubmit: _unref(agregarVehiculoSubmit)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(VipUser, {
                  title: `Registra tu ${_unref(state).evento?.marca}`,
                  descripcion: `Para ser miembro de ${_unref(state).evento?.nombre} debés registrar al menos un vehículo ${_unref(state).evento?.marca} del que seas titular. Para validarlo te pedimos que completes la siguiente información.`,
                  documento: form.documento,
                  modelValue: form.documentacion,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.documentacion) = $event)),
                  required: true,
                  "no-separador": true
                }, {
                  default: _withCtx(() => [
                    (!_unref(state).authUser?.documento)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createVNode(FormDni, {
                            label: "formularios.dni.label",
                            placeholder: "formularios.dni.placeholder",
                            modelValue: form.documento,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.documento) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_27
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["title", "descripcion", "documento", "modelValue"])
              ]),
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  class: "btn bg-light text-dark",
                  type: "submit",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (asociarAccion.value = false))
                }, " Cancelar "),
                _createElementVNode("button", {
                  class: "btn",
                  type: "submit",
                  disabled: _unref(loading).status
                }, "Asociar vehiculo", 8, _hoisted_30)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
    ])
  ]))
}
}

})